var account = "Cont";
var accountSettings = "Setările contului";
var charging = "Încărcare";
var contactInfo = "Informații de contact";
var dashboard = "Panou de bord";
var home = "Pagina principală";
var myProducts = "Produsele mele";
var orderHistory = "Istoric comenzi";
var paymentMethod = "Metodă de plată";
var profileSettings = "Setări profil";
var referAndEarn = "Recomandați și câștigați";
var signOut = "Deconectare";
var ro_RO = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, ro_RO as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
